'use strict';

module.exports = function (obj) {

  if (obj == null) {
    return false;
  }

  var o = Object(obj);

  return o === o.window;
};



//////////////////
// WEBPACK FOOTER
// ./~/is-window/index.js
// module id = 419
// module chunks = 0 1 2 3 4